"use client";
import type { SurveyQuestion, ContentImageOptions } from "@/types/survey";

interface ContentImageBlockProps {
  question: SurveyQuestion;
}

const SIZE_MAP: Record<string, string> = {
  small: "25%",
  medium: "50%",
  large: "75%",
  full: "100%",
};

export default function ContentImageBlock({ question }: ContentImageBlockProps) {
  const opts = (question.options || {}) as ContentImageOptions;
  const imageUrl = opts.imageUrl;

  if (!imageUrl) return null;

  let width: string;
  if (opts.imageSize === "custom" && opts.imageWidth) {
    width = `${opts.imageWidth}px`;
  } else {
    width = SIZE_MAP[opts.imageSize || "full"] || "100%";
  }

  const alignment = opts.imageAlignment || "center";
  const justifyContent =
    alignment === "left"
      ? "flex-start"
      : alignment === "right"
        ? "flex-end"
        : "center";

  return (
    <div className="mb-6 flex" style={{ justifyContent }}>
      {/* eslint-disable-next-line @next/next/no-img-element */}
      <img
        src={imageUrl}
        alt={opts.imageAlt || ""}
        style={{
          width,
          maxWidth: "100%",
          height: "auto",
          borderRadius: 8,
          display: "block",
        }}
      />
    </div>
  );
}
